"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGroupCurriculumItemEntityToIGroupCurriculumItem = void 0;
var tslib_1 = require("tslib");
var Group_1 = require("../entities/Group");
var entityService_1 = require("../entityService");
var IGroupCurriculumItemEntityToIGroupCurriculumItem = function (e, courses, enrolledCourseIds) {
    var items = [];
    if (e.items)
        items = e.items.map(function (x) { return (0, exports.IGroupCurriculumItemEntityToIGroupCurriculumItem)(x, courses, enrolledCourseIds); });
    if ((0, Group_1.isGroupCurriculumSectionEntity)(e)) {
        return {
            type: e.type,
            slug: "section",
            title: e.title,
            id: e.id,
            items: items
        };
    }
    var course = e.type === entityService_1.corePaths.course ? courses.find(function (x) { return x.id === e.id; }) : undefined;
    if (!course) {
        return undefined;
    }
    return tslib_1.__assign(tslib_1.__assign({}, course), { tags: course.tags, type: e.type, complete: course.percentCompleted === 100, enrolled: enrolledCourseIds === null || enrolledCourseIds === void 0 ? void 0 : enrolledCourseIds.includes(course.id) });
};
exports.IGroupCurriculumItemEntityToIGroupCurriculumItem = IGroupCurriculumItemEntityToIGroupCurriculumItem;
